import { SvcDataPrefetching, SvcDataPrefetchingItemStructure } from './svc-data-prefetching.abstract';

export abstract class SvcAppDataPrefetching<T extends SvcDataPrefetchingItemStructure> extends SvcDataPrefetching<T> {
  public abstract initDataPreparation(): T;

  public initAndFetch() {
    this.prepareDataFetching(this.initDataPreparation());
    this.fetch();
  }
}
